import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'

import styles from './styles.scss'

const Image = ({ src }) => (
  <div styleName='imgContainer'>
    <img styleName='img' src={src}/>
  </div>
)

Image.propTypes = {
  src: PropTypes.string.isRequired,
}

Image.defaultProps = {
  src: '/',
}

const withStyle = CSSModules(styles)
const enhance = compose(
  withStyle
)

export default enhance(Image)
